import { IKpiChartOverlay, IKpiChartOverlayDataRow, parseDate } from '@report-content';
import { Highcharts } from 'components/chart/Chart';
import { SeriesOverlayId, SeriesOverlayRightAxisId } from './index';
import { IKpiMeasurePointData } from './getMeasurementSeries';

export function getOverlaySeries(
    overlay: IKpiChartOverlay,
    rows: Array<IKpiChartOverlayDataRow>,
): Highcharts.SeriesLineOptions {
    const isBar = overlay.chart_type === 'Bar';
    return {
        //@ts-ignore
        type: isBar ? 'column' : 'line',
        name: overlay.title,
        id: `${SeriesOverlayId}_${overlay.id}`,
        color: overlay.color,
        yAxis: overlay.axis === 'Right' ? SeriesOverlayRightAxisId : 0,
        ...(isBar ? {} : { dashStyle: overlay.dash_style as Highcharts.DashStyleValue }),
        data: rows
            .filter((row) => row.date != null)
            .map((row) => {
                const y = row.value == null || row.value === '' ? null : Number(row.value);
                return {
                    x: parseDate(row.date).getTime(),
                    y,
                    custom: {
                        color: overlay.color,
                        name_f: overlay.title,
                        x_f: row.date,
                        y_f: row['value-formatted'] ?? (y == null ? '' : String(y)),
                    } as IKpiMeasurePointData,
                };
            }),
    };
}
